import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		headerRow: {
			marginBottom: theme.spacing(1),
		},
		cityLabel: {
			fontWeight: 600,
		},
		addressLink: {
			textAlign: "left",
		},
		banner: {
			marginBottom: theme.spacing(2),
		},
	} satisfies Record<string, CSSObject>);
};
